module.exports = __webpack_public_path__ + "static/media/new_project_sample.4f39be3c.svg";